import { queryOptions } from "@tanstack/react-query";
import type { Secret, SecretResponse } from "@/app/secrets/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { secretsKeys } from "./query-keys";

export const fetchSecrets = async ({
  client,
}: {
  client: ApiClient;
}): Promise<Secret[]> => {
  const { data } = await client.get<SecretResponse>("/secrets");
  return data?.items ?? [];
};

export const secretsQueryOptions = ({
  binding = "project",
  scope,
}: {
  binding?: ScopedBinding;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<Secret[]>({
    queryKey: secretsKeys.list({ binding, scope }),
    queryFn: () => fetchSecrets({ client }),
  });
};
